import React from 'react';
import { useTranslation } from 'react-i18next';
import { TitleHeader } from 'web-library';
import CreateDataArchival from '../../modules/admin/components/DataArchival/CreateDataArchival';

const CreateDataArchivalPage = () => {
  const { t } = useTranslation();

  return (
    <>
      <TitleHeader title={t('admin->>DataArchival.CreateDataArchival')} />

      <CreateDataArchival />
    </>
  );
};

export default CreateDataArchivalPage;
